/** Statsig gate name for org-scoped unified home rollout (user-level). */
export const ORG_SCOPED_HOME_STATSIG_GATE = 'org-scoped-home';
